var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"text-yellow-500",attrs:{"id":'rating-' + _vm.id,"title":'Content Rating: ' + _vm.rating + '/5 stars'}})}
var staticRenderFns = []

export { render, staticRenderFns }